import React from 'react';
import DOMPurify from 'dompurify';

/**
 * Renders HTML content that originates from the Tiptap admin editor
 * (Blog posts, static pages, etc.). All content is sanitized client-side
 * via DOMPurify to neutralize any XSS payload that might have been
 * injected through an admin compromise or a malicious admin user.
 *
 * Allows a generous set of formatting tags + image/link attributes used
 * by Tiptap while stripping <script>, on* handlers, javascript: URLs, etc.
 */
const SAFE_CONFIG = {
  ALLOWED_TAGS: [
    'a', 'b', 'blockquote', 'br', 'code', 'em', 'h1', 'h2', 'h3', 'h4', 'h5',
    'hr', 'i', 'img', 'li', 'ol', 'p', 'pre', 'span', 'strong', 'u', 'ul',
    'figure', 'figcaption', 'div',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'title', 'class'],
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus'],
};

const SafeHtml = ({ html, className = 'prose-content', as: Tag = 'div', ...rest }) => {
  const clean = html ? DOMPurify.sanitize(html, SAFE_CONFIG) : '';
  // eslint-disable-next-line react/no-danger -- HTML is sanitized by DOMPurify above (OWASP-approved pattern)
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: clean }} {...rest} />;
};

export default SafeHtml;
